"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomerProductLists = useCustomerProductLists;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _contexts = require("../../contexts");
var _utils = require("../../utils");
var _useCustomer = require("./useCustomer");
var _useCustomerProductLists = require("../../hooks/useCustomerProductLists");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/**
 * Custom hook to add functionality to the useCustomerProductLists hook
 */
function useCustomerProductLists(name, type) {
  const api = (0, _contexts.useCommerceAPI)();
  const customer = (0, _useCustomer.useCustomer)();
  const origUseCustomerProductLists = (0, _useCustomerProductLists.useCustomerProductLists)();
  const {
    actions
  } = (0, _react.useContext)(_contexts.CustomerProductListsContext);
  const _createList = (0, _utils.handleAsyncError)(order => {
    // @ts-ignore
    return api.shopperCustomers.createCustomerProductList({
      body: _objectSpread({
        type,
        name
      }, order),
      parameters: {
        customerId: customer.customerId
      }
    });
  });
  const getLists = (0, _utils.handleAsyncError)(() => {
    // @ts-ignore
    return api.shopperCustomers.getCustomerProductLists({
      parameters: {
        customerId: customer.customerId
      }
    });
  });
  const _updateList = (0, _utils.handleAsyncError)(order => {
    // @ts-ignore
    return api.shopperCustomers.updateCustomerProductList({
      body: _objectSpread({
        type,
        name
      }, order),
      parameters: {
        customerId: customer.customerId,
        listId: order.id
      }
    });
  });
  const _removeList = (0, _utils.handleAsyncError)(listId => {
    // @ts-ignore
    return api.shopperCustomers.deleteCustomerProductList({
      parameters: {
        listId,
        customerId: customer.customerId
      }
    });
  });
  const self = _objectSpread(_objectSpread({}, origUseCustomerProductLists), {}, {
    /**
     * Create a new list with fields
     * @returns
     */
    createList: function () {
      var _ref = (0, _asyncToGenerator2.default)(function* (order) {
        const list = yield _createList(order);
        return list;
      });
      return function createList(_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    init: function () {
      var _ref2 = (0, _asyncToGenerator2.default)(function* () {
        const lists = yield getLists();
        // Note: if the customer has no lists, the API response does NOT contain the "data" key.
        actions.receiveLists((lists === null || lists === void 0 ? void 0 : lists.data) ?? []);
        return lists;
      });
      return function init() {
        return _ref2.apply(this, arguments);
      };
    }(),
    removeList: function () {
      var _ref3 = (0, _asyncToGenerator2.default)(function* (listId) {
        yield _removeList(listId);
      });
      return function removeList(_x2) {
        return _ref3.apply(this, arguments);
      };
    }(),
    updateList: function () {
      var _ref4 = (0, _asyncToGenerator2.default)(function* (order) {
        const list = yield _updateList(order);
        actions.receiveList(list);
      });
      return function updateList(_x3) {
        return _ref4.apply(this, arguments);
      };
    }()
  });
  return self;
}